import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d20723"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "autoList" }
const _hoisted_2 = { class: "autoList__content" }
const _hoisted_3 = ["src", "title"]
const _hoisted_4 = {
  key: 0,
  style: {"color":"#52c41a"}
}
const _hoisted_5 = { class: "fl-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form = _resolveComponent("app-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_operates = _resolveComponent("app-operates")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_action_drawer = _resolveComponent("action-drawer")!
  const _component_quota_adjustment = _resolveComponent("quota-adjustment")!
  const _component_auto_edit_component = _resolveComponent("auto-edit-component")!
  const _component_multiple_quota_adjustment_modal = _resolveComponent("multiple-quota-adjustment-modal")!
  const _component_import_auto_modal = _resolveComponent("import-auto-modal")!
  const _component_batch_set_system = _resolveComponent("batch-set-system")!
  const _directive_call = _resolveDirective("call")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_app_form, {
        "search-list": _ctx.searchList,
        "search-data": _ctx.filterParams,
        onHandleSearch: _ctx.handleSearch
      }, null, 8, ["search-list", "search-data", "onHandleSearch"]),
      _createVNode(_component_app_operates, { mg: "0 0 16px 0" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-right":"10px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExportTable($event)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            style: {"margin-right":"10px"},
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增车辆")
            ]),
            _: 1
          })), [
            [
              _directive_call,
              {action: 'create' , id: 0, record: {}},
              void 0,
              { doWith: true }
            ]
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-right":"10px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onImport(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量导入车辆")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onAddQuota
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量调整额度")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.energyType !== 2)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                style: {"margin-left":"10px"},
                onClick: _ctx.onSetSystem
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量设置制度")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-left":"10px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onImport(2)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("导入车辆额度")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-left":"10px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDelCar()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("删除车辆")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-left":"10px"},
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onImport(3)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("批量删除车辆")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_app_table, {
        ref: "tableRef",
        size: "default",
        "row-key": "vehicleNo",
        "show-pagination": true,
        columns: _ctx.tableColumns,
        data: _ctx.loadTableData,
        "row-selection": _ctx.selectState,
        scroll: { x: true }
      }, {
        licensePlate: _withCtx(({ record }) => [
          (record.vehicleBrandLogo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: record.vehicleBrandLogo,
                width: "22",
                class: "listOnEmImg",
                title: record.vehicleBrandName
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(record.licensePlate), 1)
        ]),
        carType: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(record.carType === 0 ? '公车' : record.carType === 1 ? '私车' : '--'), 1)
        ]),
        vin: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(record.vin || '--'), 1)
        ]),
        num: _withCtx(({ record }) => [
          _createVNode(_component_router_link, {
            class: "underline",
            to: { name: 'auto.staff', params: { id: record.id, enterpriseId: record.enterpriseId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(record.num), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        ocrFlag: _withCtx(({ text }) => [
          (text === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "开启"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("关闭")
              ], 64))
        ]),
        quotaAmount: _withCtx(({ record }) => [
          (record.activate === 1 && record.quotaFlag === 0 )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(record.refreshCycle === 1 ? '每周 ': '每月 ') + " " + _toDisplayString(_ctx.formatCny((record.quotaAmount / 100).toString() || '')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("--")
              ], 64))
        ]),
        state: _withCtx(({ record }) => [
          _createVNode(_component_a_switch, {
            checked: record.stateBoolean,
            "onUpdate:checked": ($event: any) => ((record.stateBoolean) = $event),
            disabled: _ctx.isStateLoading,
            onClick: ($event: any) => (_ctx.changeAutoState(record))
          }, null, 8, ["checked", "onUpdate:checked", "disabled", "onClick"])
        ]),
        action: _withCtx(({ record }) => [
          _createElementVNode("span", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("a", null, [
              _createTextVNode("详情")
            ])), [
              [
                _directive_call,
                { action:'view', id: record.id, record },
                void 0,
                { doWith: true }
              ]
            ]),
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: { name: 'auto.staff', params: { id: record.id, enterpriseId: record.enterpriseId, energyType: _ctx.energyType } }
            }, {
              default: _withCtx(() => [
                _createTextVNode("管理员工")
              ]),
              _: 2
            }, 1032, ["to"]),
            _hoisted_7,
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _withModifiers(($event: any) => (_ctx.onQuotaAdjust(record)), ["prevent"])
            }, "额度管理", 8, _hoisted_8)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data", "row-selection"])
    ]),
    _createVNode(_component_action_drawer, {
      "energy-type": _ctx.energyType,
      "brand-list": _ctx.brandList,
      "vehicle-group-list": _ctx.vehicleGroupList,
      onCreateComplete: _ctx.fnDrawerClose,
      onComplete: _ctx.onRefreshTable,
      onLoadedDataAfterClick: _ctx.loadedDataAfterClick
    }, null, 8, ["energy-type", "brand-list", "vehicle-group-list", "onCreateComplete", "onComplete", "onLoadedDataAfterClick"]),
    _createVNode(_component_quota_adjustment, {
      ref: "quotaAdjustRef",
      onComplete: _ctx.onRefreshTable
    }, null, 8, ["onComplete"]),
    _createVNode(_component_auto_edit_component, {
      source: "vehicleManage",
      onComplete: _ctx.onRefreshTable
    }, null, 8, ["onComplete"]),
    _createVNode(_component_multiple_quota_adjustment_modal, { ref: "multipleQuotaAdjustmentRef" }, null, 512),
    _createVNode(_component_import_auto_modal, {
      ref: "importAutoRef",
      "energy-type": _ctx.energyType,
      "import-title": _ctx.importTitle,
      onComplete: _ctx.onRefreshTable
    }, null, 8, ["energy-type", "import-title", "onComplete"]),
    _createVNode(_component_batch_set_system, {
      ref: "batchSetSystem",
      onComplete: _ctx.onRefreshTable
    }, null, 8, ["onComplete"])
  ]))
}